import type { Translations } from './en';

export const es: Translations = {
  nav: {
    services: 'Servicios',
    portfolio: 'Portafolio',
    starModel: 'Modelo Estrella',
    partners: 'Socios',
    about: 'Acerca de',
    contact: 'Contacto',
    getStarted: 'Comenzar',
    closeMenu: 'Cerrar menu',
    openMenu: 'Abrir menu',
  },
  hero: {
    title: 'Construyendo la Excelencia Empresarial del Manana',
    subtitle: 'Impresstars orquesta operaciones empresariales de alto rendimiento a traves de nuestro innovador sistema Star Model. Desde la incorporacion hasta la estrategia de crecimiento, somos su socio en la excelencia operativa.',
    exploreServices: 'Explorar Servicios',
    learnMore: 'Saber Mas',
  },
  services: {
    eyebrow: 'Lo que hacemos',
    title: 'Nuestros Servicios',
    incorporation: {
      title: 'Servicios de Incorporacion',
      description: 'Inicie su negocio correctamente con nuestro proceso de incorporacion simplificado. Constitucion de LLC, Corp o sin fines de lucro de forma sencilla.',
    },
    aiSolutions: {
      title: 'Soluciones de IA',
      description: 'Servicios de integracion de IA personalizada incluyendo modelos de aprendizaje automatico, procesamiento de lenguaje natural y sistemas de decision automatizada.',
    },
    b2bSolutions: {
      title: 'Soluciones B2B',
      description: 'Servicios B2B integrales incluyendo desarrollo de alianzas, optimizacion de cadena de suministro y externalizacion de procesos empresariales.',
    },
    marketingStrategy: {
      title: 'Estrategia de Marketing',
      description: 'Estrategias de marketing basadas en datos adaptadas a los objetivos de su negocio, incluyendo analisis de mercado y planificacion de crecimiento.',
    },
    businessSoftware: {
      title: 'Software Empresarial',
      description: 'Identifique e implemente las soluciones de software correctas para optimizar sus operaciones y aumentar la productividad.',
    },
    brandDesign: {
      title: 'Diseno de Marca',
      description: 'Diseno profesional de logos, desarrollo de identidad de marca y materiales de marketing que dejan una impresion duradera.',
    },
    businessConsulting: {
      title: 'Consultoria Empresarial',
      description: 'Guia estrategica para optimizar sus operaciones y acelerar el crecimiento a traves de metodologias probadas.',
    },
    ctaTitle: 'Listo para Transformar su Negocio?',
    ctaText: 'Hablemos de como nuestros servicios pueden ayudarle a alcanzar sus metas.',
    ctaButton: 'Comenzar',
  },
  starModel: {
    eyebrow: 'Conectados por diseno',
    title: 'Modelos Estrella',
    description: 'Descubra nuestro ecosistema de unidades de negocio especializadas y la metodologia operativa detras de ellas.',
    learnHow: 'Como Funciona el Modelo Estrella',
    captionLeft: 'Operaciones conectadas',
    captionRight: 'Impulso compartido',
    cleaningEdge: {
      title: 'Cleaning EDGE',
      status: 'Activo',
      description: 'Servicios profesionales de limpieza reinventados a traves de tecnologia y estandares de servicio excepcionales.',
      details: 'Cleaning EDGE es una empresa de limpieza profesional enfocada en servicios confiables residenciales y comerciales, incluyendo limpieza post-construccion y detallado automotriz, con flujos de trabajo digitales que facilitan la reservacion, la comunicacion y el seguimiento del servicio.',
    },
    ozean: {
      title: 'Ozean',
      status: 'Desarrollo',
      description: 'Una plataforma de audio stock que ofrece recursos de sonido para creadores, editores, marcas y narradores.',
      details: 'Ozean se enfoca en audio stock curado, ayudando a equipos creativos a encontrar pistas y elementos de sonido para la produccion de contenido.',
    },
    visitWebsite: 'Visitar Sitio Web',
  },
  testimonials: {
    eyebrow: 'Historias de clientes',
    title: 'Testimonios de Clientes',
    description: 'No se quede solo con nuestra palabra — escuche lo que nuestros clientes tienen que decir sobre trabajar con Impresstars.',
    j94Designs: 'Impresstars nos apoyo con consultoria de RRHH y tambien nos ayudo a construir partes clave de nuestro sitio web Wix.',
    craftPapi: 'Impresstars desarrollo un plan de marketing practico para nuestro equipo, haciendo nuestras campanas y prioridades mucho mas claras.',
    pawStuffs: 'Impresstars continua apoyando nuestro sitio Shopify y proporciona soporte de servicio continuo a medida que crece nuestra tienda.',
  },
  portfolio: {
    eyebrow: 'Trabajo seleccionado',
    title: 'Nuestro Portafolio',
    description: 'Explore nuestros proyectos recientes e historias de exito en diversas industrias y servicios.',
    filterAll: 'Todos',
    filterWebsites: 'Sitios Web',
    filterApps: 'Apps y Herramientas',
    filterGames: 'Juegos',
    filterConsulting: 'Consultoria',
    production: 'Produccion',
    showcase: 'Showcase',
    viewCaseStudy: 'Ver Estudio de Caso',
    visitSite: 'Visitar Sitio',
    openProject: 'Abrir Proyecto',
    viewServices: 'Ver Nuestros Servicios',
    startProject: 'Iniciar un Proyecto',
    filterAllProjects: 'Todos los Proyectos',
    filterRealWorld: 'Produccion',
    filterShowcase: 'Showcase',
    sortFeatured: 'Destacados',
    sortAZ: 'Titulo: A-Z',
    sortZA: 'Titulo: Z-A',
    sortLabel: 'Ordenar por:',
    reset: 'Restablecer',
    showing: 'Mostrando',
    of: 'de',
    projects: 'proyectos',
    noProjects: 'No se encontraron proyectos para este filtro aun.',
    visitProjectWebsite: 'Visitar sitio web del proyecto',
    catBrandWebsite: 'Sitio Web de Marca',
    catWebDevelopment: 'Desarrollo Web',
    catEcommerceWebsite: 'Sitio Web Ecommerce',
    catBusinessWebsite: 'Sitio Web Empresarial',
    catWebsite: 'Sitio Web',
    catJewelleryBrand: 'Marca de Joyeria',
    catWebApp: 'App Web',
    catInteractiveApp: 'App Interactiva',
    catUtilityTool: 'Herramienta Util',
    cat3DWebSandbox: 'Sandbox Web 3D',
    catWebGame: 'Juego Web',
    catGameExperience: 'Experiencia de Juego',
    catConsultingMarketingPlan: 'Consultoria y Plan de Marketing',
    desc: {
      snouts: 'Trabajo web que respalda la presencia de marca en linea de Snouts.',
      innovaPro: 'Entrega de sitio web para Innova Pro enfocada en una presentacion clara de servicios y un rendimiento solido.',
      pawstuffs: 'Presencia web ecommerce y soporte de tienda para Pawstuffs.',
      cleaningEdge: 'Trabajo de sitio web y presencia digital para Cleaning EDGE.',
      cheesePanic: 'El gato persigue al raton, el raton quiere queso. Un pequeno juego web caotico.',
      cleaningEdgeApp: 'Plataforma de autoservicio enfocada en operaciones para clientes y trabajadores de Cleaning EDGE. Pruebe la demo de desarrollo con la contrasena cleaningEDGE, y asegurese de seleccionar Legacy Mode.',
      angoloDiamonds: 'Trabajo de desarrollo web para Angolo Diamonds.',
      craftPapiGrowth: 'Desarrollo de plan de consultoria y marketing para Craft Papi para fortalecer el posicionamiento y la ejecucion del crecimiento.',
      roboticVoiceClicker: 'Experiencia de clicker activada por voz con interaccion ludica de boton lagarto.',
      cheatCounter: 'Jorge miro nuevamente la carta superior de su biblioteca. Alguien tenia que llevar la cuenta.',
      klondikeSolitaire: 'Presentacion e interaccion de juego web inspirado en el solitario clasico.',
      universeAdventure: 'Concepto de aventura espacial que incluye viajes galacticos y exploracion basada en naves.',
      interiorDesign3d: 'Un sandbox de navegador Three.js para importar modelos 3D y construir escenas de interiores.',
      pavillionJewellery: 'Presentacion de sitio web enfocada en marca para Pavillion Jewellery.',
      hauntedGalleria: 'Un sitio web inmersivo de tema oscuro para una experiencia de galeria encantada con visuales atmosfericos y animaciones espeluznantes.',
    },
  },
  partners: {
    eyebrow: 'Tecnologia Confiable',
    title: 'Herramientas que Usamos y Recomendamos',
    description: 'Estas son plataformas con las que trabajamos activamente y recomendamos a nuestros clientes. Si se registra a traves de nuestros enlaces, podemos ganar una referenciacion — sin costo adicional para usted.',
    teaserEyebrow: 'Tecnologia Confiable',
    teaserTitle: 'Herramientas que Recomendamos',
    seeAllPartners: 'Ver Todos los Socios',
    getStarted: 'Comenzar',
    ctaTitle: 'Necesita Ayuda para Elegir el Stack Correcto?',
    ctaText: 'Evaluamos, implementamos e integramos herramientas en su flujo de trabajo. Deje que manejemos la tecnologia para que usted pueda enfocarse en su negocio.',
    ctaButton: 'Hablemos',
    disclaimer: 'Algunos enlaces en esta pagina son enlaces de referenciacion. Impresstars puede ganar una comision si se registra — sin costo adicional para usted.',
    catProductivity: 'Productividad',
    catAIVoice: 'IA y Voz',
    catBusinessPhone: 'Telefono Empresarial',
    catAIWebBuilder: 'Constructor Web IA',
  },
  about: {
    eyebrow: 'Nuestro proposito',
    title: 'Acerca de Impresstars',
    p1: 'En Impresstars, creemos en transformar las operaciones empresariales a traves de la innovacion y la excelencia. Nuestra mision es ayudar a las empresas a alcanzar su maximo potencial implementando soluciones de vanguardia y metodologias probadas.',
    p2: 'Fundados sobre los principios de excelencia operativa y crecimiento sostenible, hemos desarrollado nuestro unico sistema Star Model que ha ayudado a numerosos negocios a lograr un exito remarkable.',
  },
  clients: {
    title: 'Nuestros Clientes',
    description: 'Estamos orgullosos de trabajar con estas organizaciones y ayudarlas a crecer a traves de nuestros servicios y soporte dedicado.',
  },
  techPlatforms: {
    title: 'Tecnologias y Plataformas que Apoyamos',
    description: 'Podemos ayudar con implementacion, optimizacion o soporte en estas herramientas y plataformas.',
    catEcommerce: 'E-commerce y Sitios Web',
    catAI: 'IA y Automatizacion',
    catMarketing: 'Marketing y Crecimiento',
    catCloud: 'Nube e Infraestructura',
    catCreative: 'Produccion Creativa y de Marca',
    focusEcommerce: 'Competencia central: lanzamiento y soporte de tiendas y sitios web enfocados en conversion.',
    focusAI: 'Competencia central: adopcion practica de IA y automatizacion de flujos de trabajo para equipos en crecimiento.',
    focusMarketing: 'Competencia central: seguimiento de rendimiento, ejecucion de campanas y SEO fundamental.',
    focusCloud: 'Competencia central: despliegue confiable y soporte de entornos para operaciones web modernas.',
    focusCreative: 'Competencia central: activos de ejecucion de marca que respaldan el marketing y la narrativa de productos.',
  },
  contact: {
    title: 'Pongase en Contacto',
    description: 'Listo para transformar su negocio? Envienos un mensaje y le responderemos dentro de 24 horas.',
    name: 'Nombre',
    namePlaceholder: 'Su nombre',
    email: 'Correo electronico',
    emailPlaceholder: 'su@correo.com',
    reason: 'Motivo de Contacto',
    reasonPlaceholder: 'Seleccione un motivo',
    message: 'Mensaje',
    messagePlaceholder: 'Como podemos ayudarle?',
    sending: 'Enviando...',
    send: 'Enviar Mensaje',
    successTitle: 'Mensaje Enviado!',
    successText: 'Gracias por contactarnos. Le responderemos pronto.',
    sendAnother: 'Enviar Otro Mensaje',
    recaptchaError: 'Por favor complete la verificacion reCAPTCHA.',
    submitError: 'El envio fallo. Intente nuevamente o enviemos un correo directamente.',
    reasons: {
      incorporationServices: 'Servicios de Incorporacion',
      aiSolutions: 'Soluciones de IA',
      b2bSolutions: 'Soluciones B2B',
      marketingStrategy: 'Estrategia de Marketing',
      businessSoftware: 'Software Empresarial',
      brandDesign: 'Diseno de Marca',
      businessConsulting: 'Consultoria Empresarial',
      websiteDevelopment: 'Desarrollo Web',
      websiteSupport: 'Soporte / Mantenimiento Web',
      ecommerceSupport: 'Soporte Ecommerce',
      generalQuestion: 'Pregunta General',
      partnership: 'Oportunidad de Asociacion',
    },
  },
  footer: {
    tagline: 'Transformando operaciones empresariales a traves de la innovacion y la excelencia.',
    quickLinks: 'Enlaces Rapidos',
    starModels: 'Modelos Estrella',
    legal: 'Legal',
    termsConditions: 'Terminos y Condiciones',
    privacyPolicy: 'Politica de Privacidad',
    contactTitle: 'Contacto',
    city: 'London, ON',
    country: 'Canada',
    rightsReserved: 'Impresstars. Todos los derechos reservados.',
    notALawFirm: 'Impresstars no es una firma de abogados y no proporciona asesoramiento legal.',
  },
  notFound: {
    title: 'Pagina No Encontrada',
    metaDescription: 'La pagina que busca no existe o se ha movido.',
    heading: 'Pagina No Encontrada',
    text: 'La pagina que busca no existe o puede haberse movido. Vamos a ponerle de vuelta en camino.',
    backHome: 'Volver al Inicio',
    contactUs: 'Contactenos',
    portfolio: 'Portafolio',
    services: 'Servicios',
  },
  caseStudy: {
    notFound: 'Estudio de Caso No Encontrado',
    returnHome: 'Volver al Inicio',
    backToPortfolio: 'Volver al Portafolio',
    client: 'Cliente:',
    challenge: 'El Desafio',
    solution: 'Nuestra Solucion',
    keyResults: 'Resultados Clave',
    technologiesUsed: 'Tecnologias Utilizadas',
    visitProject: 'Visitar Proyecto',
    items: {
      cleaningEdgePlatform: {
        title: 'Plataforma Cleaning EDGE',
        category: 'Desarrollo Web',
        client: 'Cleaning EDGE',
        description: 'Una plataforma digital integral para gestionar servicios de limpieza, incluyendo programacion, gestion de equipos y comentarios de clientes.',
        challenge: 'El cliente necesitaba una solucion escalable para gestionar sus crecientes operaciones de servicio de limpieza, manejar reservas de clientes y optimizar la programacion de equipos en multiples ubicaciones.',
        solution: 'Desarrollamos una plataforma web personalizada que integra gestion de reservas, programacion de equipos y seguimiento en tiempo real. La solucion incluye un portal de clientes, panel de administracion e interfaz adaptada a moviles para equipos de limpieza.',
        results: [
          'Reduccion de conflictos de programacion en 95%',
          'Aumento de la satisfaccion del cliente al 98%',
          'Mejora de la eficiencia del equipo en 40%',
          'Habilitacion de expansion a 3 nuevas ubicaciones',
        ],
      },
      aiAnalyticsDashboard: {
        title: 'Panel de Analitica con IA',
        category: 'Soluciones de IA',
        client: 'TechVision Inc.',
        description: 'Panel de analitica personalizado usando aprendizaje automatico para predecir tendencias empresariales y optimizar operaciones.',
        challenge: 'El cliente tenia dificultades para dar sentido a su vasta recoleccion de datos y necesitaba insights predictivos para tomar mejores decisiones empresariales.',
        solution: 'Implementamos un sistema de aprendizaje automatico que analiza datos historicos, predice tendencias y proporciona insights accionables a traves de una interfaz de panel intuitiva.',
        results: [
          'Aumento de la precision de prediccion en 85%',
          'Reduccion del tiempo de toma de decisiones en 60%',
          'Generacion de $2M en ahorro de costos',
          'Mejora de la gestion de inventario en 45%',
        ],
      },
      globalMarketingCampaign: {
        title: 'Campana de Marketing Global',
        category: 'Estrategia de Marketing',
        client: 'Global Solutions Ltd',
        description: 'Estrategia integral de marketing digital que aumento la presencia en el mercado del cliente en tres continentes.',
        challenge: 'El cliente necesitaba expandir su presencia en el mercado globalmente mientras mantenia un mensaje de marca consistente y compromiso en diferentes contextos culturales.',
        solution: 'Desarrollamos una estrategia de marketing multicanal con contenido localizado, publicidad dirigida y adaptacion cultural de los materiales de marketing.',
        results: [
          'Alcanzamos mas de 2M de nuevos clientes potenciales',
          'Aumento de ventas globales en 150%',
          'Mejora del reconocimiento de marca en 80%',
          'Generacion de 300% de ROI en gasto de marketing',
        ],
      },
      hauntedGalleria: {
        title: 'Haunted Galleria',
        category: 'Diseno y Desarrollo Web',
        client: 'Haunted Galleria',
        description: 'Un sitio web inmersivo de tema oscuro para una experiencia de galeria encantada — combinando visuales atmosfericos, animaciones espeluznantes y tipografia audaz.',
        challenge: 'El cliente necesitaba una presencia web que coincidiera con la naturaleza dramatica y misteriosa de su concepto de galeria encantada.',
        solution: 'Creamos un sitio completamente personalizado con estetica oscura ambiental, efectos de paralaje y tipografia inspirada en el horror para generar suspenso.',
        results: [
          'Identidad de marca destacada en un nicho de mercado',
          'UX inmersiva que mantiene a los visitantes comprometidos mas tiempo',
          'Totalmente responsive en todos los dispositivos',
          'Optimizado para tiempos de carga rapidos con efectos visuales ricos',
        ],
      },
    },
  },
  servicePages: {
    incorporation: {
      title: 'Servicios de Incorporacion',
      metaDescription: 'Inicie su viaje empresarial con confianza. Nuestros servicios de incorporacion proporcionan una base solida para el futuro exito de su empresa.',
      intro: 'Inicie su viaje empresarial con confianza. Nuestros servicios de incorporacion proporcionan una base solida para el futuro exito de su empresa.',
      disclaimer: 'Aviso: Impresstars no es una firma de abogados y no proporciona asesoramiento legal. Recomendamos consultar a un abogado calificado para guia legal.',
      structureOptions: 'Opciones de Estructura Empresarial',
      structureItems: [
        'Compania de Responsabilidad Limitada (LLC)',
        'Corporacion (C-Corp, S-Corp)',
        'Organizacion Sin Fines de Lucro',
        'Formaciones de Asociaciones',
      ],
      included: 'Que Incluye',
      includedItems: [
        'Busqueda de Nombre Comercial',
        'Articulos de Incorporacion',
        'Registro EIN',
        'Acuerdo Operativo',
      ],
      ctaTitle: 'Listo para Incorporarse?',
      ctaText: 'Hablemos sobre la mejor estructura para su negocio y pongamole en el camino correcto.',
      ctaButton: 'Agendar una Consulta',
    },
    aiSolutions: {
      title: 'Soluciones de IA',
      metaDescription: 'Transforme su negocio con soluciones de inteligencia artificial de vanguardia adaptadas a sus necesidades especificas.',
      intro: 'Transforme su negocio con soluciones de inteligencia artificial de vanguardia adaptadas a sus necesidades especificas.',
      servicesTitle: 'Servicios de IA',
      servicesItems: [
        'Modelos de Aprendizaje Automatico',
        'Procesamiento de Lenguaje Natural',
        'Soluciones de Vision por Computadora',
        'Analitica Predictiva',
      ],
      implAreas: 'Areas de Implementacion',
      implItems: [
        'Automatizacion de Servicio al Cliente',
        'Analisis de Datos e Insights',
        'Optimizacion de Procesos',
        'Sistemas de Soporte a Decisiones',
      ],
      ctaTitle: 'Listo para Implementar IA?',
      ctaText: 'Exploremos como la IA puede revolucionar sus operaciones empresariales e impulsar el crecimiento.',
      ctaButton: 'Comenzar',
    },
    b2bSolutions: {
      title: 'Soluciones B2B',
      metaDescription: 'Optimice sus operaciones business-to-business con nuestras soluciones integrales disenadas para empresas modernas.',
      intro: 'Optimice sus operaciones business-to-business con nuestras soluciones integrales disenadas para empresas modernas.',
      coreServices: 'Servicios Principales',
      coreServicesItems: [
        'Optimizacion de Cadena de Suministro',
        'Desarrollo de Alianzas',
        'Externalizacion de Procesos',
        'Planificacion Estrategica',
      ],
      benefits: 'Beneficios',
      benefitsItems: [
        'Eficiencia Aumentada',
        'Reduccion de Costos',
        'Expansion de Mercado',
        'Crecimiento de Ingresos',
      ],
      ctaTitle: 'Transforme Sus Operaciones B2B',
      ctaText: 'Optimicemos sus relaciones y procesos empresariales para maxima eficiencia.',
      ctaButton: 'Contactenos',
    },
    marketingStrategy: {
      title: 'Estrategia de Marketing',
      metaDescription: 'Desarrolle una poderosa estrategia de marketing que impulse el crecimiento y conecte con su publico objetivo.',
      intro: 'Desarrolle una poderosa estrategia de marketing que impulse el crecimiento y conecte con su publico objetivo.',
      strategyComponents: 'Componentes de Estrategia',
      strategyItems: [
        'Analisis de Mercado',
        'Investigacion de Competidores',
        'Perfilacion de Publico Objetivo',
        'Estrategia de Canales',
      ],
      deliverables: 'Entregables',
      deliverablesItems: [
        'Plan de Marketing',
        'Estrategia de Contenido',
        'Hoja de Ruta de Campanas',
        'Proyecciones de ROI',
      ],
      ctaTitle: 'Listo para Crecer?',
      ctaText: 'Creemos una estrategia de marketing que lleve su negocio al siguiente nivel.',
      ctaButton: 'Comenzar Planificacion',
    },
    brandDesign: {
      title: 'Diseno de Marca',
      metaDescription: 'Cree una identidad de marca memorable que resuene con su audiencia y destaque en el mercado.',
      intro: 'Cree una identidad de marca memorable que resuene con su audiencia y destaque en el mercado.',
      designServices: 'Servicios de Diseno',
      designItems: [
        'Diseno de Logo',
        'Guias de Marca',
        'Identidad Visual',
        'Materiales de Marketing',
      ],
      deliverables: 'Entregables',
      deliverablesItems: [
        'Guia de Estilo de Marca',
        'Paquete de Logo',
        'Paleta de Colores',
        'Sistema de Tipografia',
      ],
      ctaTitle: 'Listo para un Nuevo Look?',
      ctaText: 'Creemos una identidad de marca que capture su vision y conecte con su audiencia.',
      ctaButton: 'Iniciar Proceso de Diseno',
    },
    businessConsulting: {
      title: 'Consultoria Empresarial',
      metaDescription: 'Obtenga guia experta para optimizar sus operaciones y acelerar el crecimiento empresarial a traves de metodologias probadas.',
      intro: 'Obtenga guia experta para optimizar sus operaciones y acelerar el crecimiento empresarial a traves de metodologias probadas.',
      consultingAreas: 'Areas de Consultoria',
      consultingItems: [
        'Planificacion Estrategica',
        'Optimizacion de Operaciones',
        'Analisis Financiero',
        'Estrategia de Crecimiento',
      ],
      benefits: 'Beneficios',
      benefitsItems: [
        'Eficiencia Mejorada',
        'Reduccion de Costos',
        'Crecimiento de Ingresos',
        'Mejor Toma de Decisiones',
      ],
      ctaTitle: 'Listo para Optimizar?',
      ctaText: 'Analizemos su negocio y creemos una hoja de ruta para un crecimiento sostenible.',
      ctaButton: 'Reservar Consulta',
    },
    businessSoftware: {
      title: 'Soluciones de Software Empresarial',
      metaDescription: 'Transforme sus operaciones empresariales con soluciones de software cuidadosamente seleccionadas e implementadas que optimizan procesos y aumentan la eficiencia.',
      intro: 'Transforme sus operaciones empresariales con soluciones de software cuidadosamente seleccionadas e implementadas que optimizan procesos y aumentan la eficiencia.',
      ourApproach: 'Nuestro Enfoque',
      approachItems: [
        'Analisis de Procesos Empresariales',
        'Recopilacion de Requisitos de Software',
        'Evaluacion y Seleccion de Soluciones',
        'Implementacion e Integracion',
      ],
      solutionAreas: 'Areas de Solucion',
      solutionItems: [
        'Sistemas ERP',
        'Plataformas CRM',
        'Herramientas de Gestion de Proyectos',
        'Desarrollo de Software Personalizado',
      ],
      ctaTitle: 'Listo para Optimizar Sus Operaciones?',
      ctaText: 'Identifiquemos las soluciones de software perfectas para transformar sus procesos empresariales.',
      ctaButton: 'Agendar Consulta',
    },
  },
  seo: {
    homeTitle: 'Construyendo la Excelencia Empresarial del Manana',
    homeDescription: 'Impresstars orquesta operaciones empresariales de alto rendimiento a traves de nuestro innovador sistema Star Model. Desde la incorporacion hasta la estrategia de crecimiento, somos su socio en la excelencia operativa.',
    portfolioTitle: 'Portafolio',
    portfolioDescription: 'Explore nuestra coleccion completa de proyectos exitosos y estudios de caso en diversas industrias.',
    partnersTitle: 'Herramientas y Socios Recomendados',
    partnersDescription: 'Herramientas y plataformas que Impresstars usa y recomienda para clientes. Comience con tecnologia de primera clase a traves de nuestros enlaces de referenciacion.',
  },
  languageSwitcher: {
    label: 'Idioma',
  },
};
